import React, { useCallback, FC } from "react";
import LoginComponent, { EAction } from "components/Login";
import { useDispatch, useSelector } from "react-redux";
import { setLocation, setStoreId, switchStore } from "store/actions/auth.actions";
import { IState } from "store/store.interface";
import { EStores } from "store/reducers/auth.reducers";
import useAuthenticate from '../../hooks/useAuthenticate'


const Login: FC = () => {
  const dispatch = useDispatch();
  const { roles = [], name, storeIds } = useSelector(
    (state: IState) => ({
      ...state.auth,
      ...state.config,
    })
  );

  const { isAuthenticated } = useAuthenticate();

  const onCountrySelectHandler = useCallback(
    (selectedStoreId: string) => {
      dispatch(setStoreId(selectedStoreId as EStores));
      dispatch(switchStore(selectedStoreId as EStores, () => {
        dispatch(setLocation("/"));
      }));
    },
    [dispatch]
  );

  return (
    <LoginComponent
      onCountrySelection={onCountrySelectHandler}
      action={isAuthenticated ? EAction.CountrySelect : EAction.Auth}
      role={roles[0]}
      stores={storeIds}
      name={name}
    />
  );
};

export default Login;
